$.appTypes = ['Memoirs', 'Sports', 'Tribute'];